export default {
  v3OfficialTopUpCenterTitle: 'Trung Tâm Nạp Web',
  v3OfficialTopUpCenterKeyword: 'Trung Tâm Nạp Web',
  v3OfficialTopUpCenterDescription: 'Trung Tâm Nạp Web',
  v3SafeAndFast: 'An toàn không rủi ro, nhận tiền nhanh chóng',
  v3Shop: 'Cửa hàng',
  v3ShoppingCart: 'Giỏ hàng',
  v3MembershipCenter: 'Trung tâm quyền lợi (Trung tâm hội viên)',
  v3Login: 'Đăng nhập',
  v3Account: 'Tài khoản',
  v3EnterAccountName: 'Vui lòng nhập tên tài khoản',
  v3Password: 'Mật khẩu',
  v3EnterPassword: 'Vui lòng nhập mật khẩu',
  v3ForgotPassword: 'Quên mật khẩu',
  v3EnterUID: 'Vui lòng nhập UID',
  v3OTP: 'OTP',
  v3EnterOTP: 'Vui lòng nhập OTP',
  v3SelectTopUpCharacter: 'Chọn nhân vật nạp tiền',
  v3SelectServer: 'Chọn cụm server',
  v3Confirm: 'Xác nhận',
  v3CharacterNotFound:
    'Nếu không tìm thấy nhân vật, vui lòng đăng nhập nhân vật trong APP trước khi vào trang nạp hoặc liên hệ CSKH',
  v3Logout: 'Đăng xuất',
  v3SwitchAccount: 'Đổi tài khoản',
  v3MyCoupons: 'Voucher của tôi',
  v3BenefitsCenter: 'Trung tâm hội viên',
  v3TopUpBenefits: 'Phúc lợi nạp tiền',
  v3MoreSettings: 'Thêm cài đặt',
  v3RememberLoginStatus: 'Nhớ trạng thái đăng nhập của tôi',
  v3OrderQuery: 'Tra cứu đơn hàng',
  v3ContactCustomerService: 'Liên hệ CSKH',
  v3LoginWithApp: 'Đăng nhập qua APP',
  v3ChooseOtherLoginMethod: 'Chọn cách đăng nhập khác',
  v3ConnectingToGameApp: 'Đang liên kết với APP',
  v3EnsureGameInstalled:
    'Hãy đảm bảo thiết bị đã cài đặt trò chơi. Nếu trò chơi không phản hồi hoặc đăng nhập thất bại, hãy cập nhật trò chơi lên phiên bản mới nhất từ cửa hàng ứng dụng hoặc thử trình duyệt khác.',
  v3OpenGame: 'Mở trò chơi',
  v3DownloadGame: 'Tải xuống trò chơi',
  v3UpdateGameIfOpenFails:
    'Nếu mở trò chơi thất bại, vui lòng cập nhật lên phiên bản mới nhất từ cửa hàng ứng dụng',
  v3ClickToDownloadLatestVersion:
    'Hoặc nhấn vào nút tải xuống trò chơi để tải phiên bản mới nhất',
  v3LoggingIntoOfficialTopUpCenter:
    'Bạn đang đăng nhập vào [Trung Tâm Nạp Web]',
  v3CurrentAccount: 'Tài khoản hiện tại: xxxxxxxxxx',
  v3WelcomeToOfficialTopUpCenter: 'Chào mừng đến với Trung Tâm Nạp Web',
  v3OfficialAuthorizedLogin:
    'Đăng nhập ủy quyền chính thức, an toàn không rủi ro',
  v3TermsOfService: 'Điều khoản dịch vụ',
  v3PrivacyPolicy: 'Chính sách bảo mật',
  v3ThirdPartySocialAccountDescription:
    'Giải thích về tài khoản xã hội bên thứ ba',
  v3BindSocialAccountInGameFirst:
    'Hãy liên kết tài khoản xã hội trong Trung Tâm Người Dùng trong trò chơi, sau đó dùng tài khoản xã hội đã liên kết để đăng nhập.',
  v3FirstTopUp15PercentOff:
    'Lần nạp đầu tiên được hưởng ưu đãi cao nhất 15% OFF',
  v3MoreTopUpRebates: 'Cực nhiều ưu đãi nạp',
  v3LoginToViewOffers: 'Đăng nhập để xem ưu đãi',
  v3TopUpEnvironmentChecking: 'Đang kiểm tra môi trường...',
  v3SafeToUse: 'An toàn, yên tâm sử dụng',
  v3LimitedTimeBenefits: 'Phúc lợi hạn giờ',
  v3EventRules: 'Quy tắc hoạt động',
  v3MoreEvents: 'Thêm nhiều hoạt động',
  v3Claim: 'Nhận',
  v3Completed: 'Đã hoàn thành',
  v3GoTo: 'Tới',
  v3ViewDetails: 'Xem chi tiết',
  v3RecommendedProducts: 'Sản phẩm đề xuất',
  v3SearchProductName: 'Tìm kiếm tên sản phẩm',
  v3AllCategories: 'Tất cả danh mục',
  v3PopularSort: 'Sắp xếp phổ biến',
  v3PriceAscending: 'Giá tăng dần',
  v3PriceDescending: 'Giá giảm dần',
  v3DiamondBonus10Percent: 'Kim Cương cộng thêm 10%',
  v3YuanbaoBonus10Percent: 'KNB cộng thêm 10%',
  v3ExtraBonus10Percent: 'Tặng thêm 10%',
  v3FirstTopUpDouble: 'Nạp đầu nhân đôi',
  v3FirstExtraBonus: 'Lần đầu tặng thêm',
  v3ProductDetails: 'Chi tiết sản phẩm',
  v3AddToCart: 'Thêm vào giỏ hàng',
  v3AddedToCart: 'Đã thêm vào giỏ hàng',
  v3BuyNow: 'Mua ngay',
  v3NoItemsInCart: 'Bạn chưa chọn sản phẩm nào vào giỏ hàng',
  v3SelectedItemsN: 'Sản phẩm đã chọn (${n})',
  v3RemoveFromCart: 'Xóa khỏi giỏ hàng?',
  v3Yes: 'Có',
  v3No: 'Không',
  v3LimitOnePerPurchase: 'Sản phẩm này giới hạn mua 1 món mỗi lần',
  v3ItemPrice: 'Giá sản phẩm',
  v3Tax: 'Thuế',
  v3TaxNotIncluded: 'Chưa bao gồm thuế',
  v3TaxIncluded: 'Đã bao gồm thuế (${tax})',
  v3ExtraGift: 'Tặng thêm',
  v3Total: 'Tổng cộng',
  v3ProceedToPayment: 'Thanh toán',
  v3SelectCoupon: 'Chọn Voucher',
  v3UnavailableCoupons: 'Voucher không khả dụng',
  v3OneCouponPerOrder: 'Mỗi đơn hàng chỉ dùng 1 Voucher',
  v3DiscountCoupon: 'Voucher chiết khấu',
  v3ThresholdCoupon: 'Voucher giảm giá theo giá trị',
  v3MinSpendCoupon: 'Dùng khi đạt xx USD',
  v3MaxDiscountCoupon: 'Tối đa giảm xxxx USD',
  v3LimitedChannel: 'Dùng với kênh giới hạn',
  v3AllChannels: 'Dùng với tất cả các kênh',
  v3SpecificProducts: 'Dùng cho sản phẩm chỉ định',
  v3AllProducts: 'Dùng cho tất cả sản phẩm',
  v3NotYetTimeToUse: 'Chưa đến thời gian sử dụng',
  v3Expired: 'Đã hết hạn',
  v3Used: 'Đã sử dụng',
  v3ValidityPeriod: 'Hiệu lực đến:',
  v3ConfirmUse: 'Xác nhận dùng',
  v3ChangeProduct: 'Thay đổi sản phẩm',
  v3ConfirmPaymentOrder: 'Xác nhận thanh toán',
  v3StoredValueRole: 'Nhân vật nạp tiền',
  v3TotalNProducts: 'Tổng cộng ${n} sản phẩm',
  v3SelectPaymentMethod: 'Hãy chọn phương thức thanh toán',
  v3PayNow: 'Thanh toán ngay',
  v3MorePaymentMethods: 'Thêm phương thức thanh toán',
  v3NoAvailablePaymentMethodContactSupport:
    'Không tìm thấy phương thức thanh toán khả dụng? Liên hệ CSKH',
  v3AvailableCoupons: 'Voucher khả dụng',
  v3Extra10Percent: 'Cộng thêm 10%',
  v3LastSelection: 'Lựa chọn lần trước',
  v3RecommendedUsage: 'Đề xuất sử dụng',
  v3PopularChoice: 'Lựa chọn phổ biến',
  v3PaymentSuccess: 'Thanh toán thành công',
  v3PaymentFailure: 'Thanh toán thất bại',
  v3TopUpFailureMessage:
    'Rất tiếc, nạp tiền thất bại. Vui lòng thử đặt lại đơn hàng hoặc liên hệ với chúng tôi qua nút CSKH bên dưới',
  v3Game: 'Trò Chơi',
  v3UID: 'UID',
  v3OrderNumber: 'Mã đơn hàng',
  v3ProductContent: 'Nội dung sản phẩm',
  v3ViewProductDetails: 'Xem chi tiết sản phẩm',
  v3PaymentMethod: 'Phương thức thanh toán',
  v3Complete: 'Hoàn thành',
  v3TopUpAgain: 'Nạp lần nữa',
  v3FriendlyReminderSaveOrderInfo:
    'Lưu ý: Chụp màn hình lưu thông tin đơn hàng để chúng tôi có thể xử lý nhanh chóng',
  v3RechargeAgain: 'Nạp lại',
  v3TransactionInProgress: 'Đang xử lý giao dịch',
  v3CompletePaymentInChannel:
    'Vui lòng truy cập kênh thanh toán để hoàn tất thanh toán đơn hàng',
  v3RestAssuredFastDeliveryAfterPayment:
    'Đừng lo, khi chúng tôi nhận được kết quả thanh toán sẽ phát hàng nhanh nhất cho bạn',
  v3SaveOrderInfoForProgress:
    'Bạn có thể chụp màn hình để theo dõi tiến độ giao dịch',
  v3PaymentCompleted: 'Tôi đã hoàn tất thanh toán',
  v3AddToHomeScreen: 'Thêm vào màn hình chính',
  v3AddShortcutForBonus: 'Thêm phím tắt trên màn hình để nhận thêm thưởng',
  v3ShareSuccess: 'Chia sẻ thành công',
  v3ShareFailure: 'Chia sẻ thất bại',
  v3RewardClaimed: 'Nhận thưởng thành công',
  v3RewardClaimFailed: 'Nhận thưởng thất bại',
  v3EventNotStarted: 'Hoạt động chưa mở',
  v3EventEnded: 'Hoạt động đã kết thúc',
  v3ClickSelectCoupon: 'Nhấn để chọn phiếu giảm giá',
  v3CouponsRecommendedUsed: 'Đã sử dụng phiếu giảm giá được đề xuất',
  v3CouponsSelected: 'Phiếu giảm giá đã chọn',
  v3NoCouponsAvaliable: 'Không có phiếu giảm giá khả dụng',
  v3SupplementStatus: 'Trạng thái',
  v3SupplementNormal: 'Bình thường',
  v3SupplementBanned: 'Đã bị cấm',
  v3SupplementPendingPayment: 'Chờ thanh toán',
  v3SupplementSwitchCharacter: 'Chuyển đổi nhân vật',
  v3SupplementAccountInfoInvalid: 'Thông tin tài khoản không hợp lệ',
  v3SupplementContactGSForTopUpLink:
    'Vui lòng liên hệ GS để nhận liên kết nạp tiền',
  v3SupplementTopUpCompleted: 'Đã hoàn thành nạp tiền:',
  v3SupplementTotalRefundOrders: 'Tổng số đơn hàng hoàn tiền: {}',
  v3SupplementPendingSupplementAmount: 'Số tiền chờ thanh toán: ',
  v3SupplementAccountCharacterNormalNoPaymentNeeded:
    'Tài khoản/nhân vật bình thường, không cần thanh toán',
  v3SupplementEnjoyYourGame: 'Chúc bạn chơi game vui vẻ!!',
  v3SupplementOrderInformation: 'Thông tin đơn hàng',
  v3SupplementPendingPaymentAmount: 'Số tiền chờ thanh toán: ',
  v3LookUpCouponRule: 'Xem quy tắc phát hành Phiếu ưu đãi',
  v3SwitchOldVersion: 'Chuyển sang phiên bản cũ Nền tảng thanh toán',
  v3FirstTopUpGiveaway: 'Nạp lần đầu tặng',
  v3SecureConnection: 'Đang kết nối an toàn',
  v3RequestTimeOut: 'Tải quá giờ, vui lòng thử lại',
  v3ConfirmLeave: 'Xác nhận rời?',
  v3NoSubmitOrder:
    'Giỏ hàng chưa thanh toán, sau khi rời sẽ bỏ qua vật phẩm mình thích!',
  v3ContinueSubmit: 'Mua tiếp',
  v3LeaveSubmit: 'Rời',
  v3RecentBug: 'Mua gần đây',
  v3ScanCodeLogin: 'Scan Code Login',
  v3BindRole: 'Bind Role',
  v3ScanLoading: 'loading...',
  v3ScanExpired: 'QR code expired',
  v3ScanRefreshClick: 'Click to refresh',
  v3ScanRefreshTip: 'Please refresh and scan again',
  v3ScanRefresh: 'Refresh',
  v3ScanSucc: 'Scanned successfully',
  v3ScanAuth: 'Please confirm on your phone',
  v3ScanAuthSuccess: 'Authorization successful',
  v3ScanAuthSuccessTip: 'Logging in...',
  v3ScanUnauthorized: 'Authorization failed',
  v3ScanRefreshTip2: 'Log in to the game app to scan',
  v3ScanGuide: 'Scan Guide',
  v3ScanLoginError: 'Login error, please refresh and retry',
  v3ThirdPartyLogin: 'Third-party Login',
  v3NoMyLoginMethod: "Don't have my login method?",
  v3AccountPasswordLogin: 'Please enter account to bind game character',
  v3PwaTapShareOrMenuIcon: 'Nhấn vào biểu tượng Chia sẻ hoặc Menu trên thanh công cụ trình duyệt',
  v3PwaFindAndTapAddToHomeScreen: 'Tìm và nhấn vào "Thêm vào màn hình chính" trong các tùy chọn',
  v3LaunchFromDesktopAndRewardToMailbox: 'Please launch from the desktop\nSelect a character and the reward will be sent to your mailbox',
  v3ClaimSuccessCheckMailbox: 'Nhận thành công\nVui lòng kiểm tra Thư trong game',
  v3ProductLimitOnceBadge: '1 lần duy nhất',
  v3ProductWeeklyOnlyBadge: 'hàng tuần',
  v3ProductMonthlyOnlyBadge: 'hàng tháng',
  v3ProductWebExclusiveBadge: 'Web độc quyền',
  v3CartMutexProductTip: 'Sản phẩm này hiện không thể thêm vào giỏ hàng.\nVui lòng làm trống giỏ hàng trước khi mua.',
  v3ProductDiscountBadge: '**% GIẢM',
};
